var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95718 2.27712C10.0379 2.47139 10.0043 2.63709 9.8579 2.77422L6.36144 6.27536V11.5449C6.36577 11.6351 6.34133 11.7243 6.29164 11.7996C6.24195 11.875 6.16959 11.9326 6.08501 11.9642C6.02865 11.9868 5.9686 11.9989 5.90786 11.9999C5.84811 12.0013 5.78875 11.99 5.7337 11.9667C5.67865 11.9435 5.62918 11.9087 5.58858 11.8649L3.77285 10.0465C3.72982 10.0053 3.69571 9.95567 3.67261 9.90076C3.64952 9.84585 3.63793 9.78678 3.63856 9.72721V6.27536L0.142103 2.77422C-0.0043264 2.63709 -0.0378981 2.47139 0.0428168 2.27712C0.123532 2.09285 0.262819 2 0.461392 2H9.53932C9.73718 2.00071 9.87647 2.09285 9.95718 2.27712Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5619b2474022a175d8d1e12b140b60bc.svg";
export { ForwardRef as ReactComponent };